import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './component/main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { NavigationModule } from '@core/navigation/navigation.module';
import { PreAuthLayoutComponent } from './component/pre-auth-layout/pre-auth-layout.component';
import { SharedModule } from '@shared/shared.module';


@NgModule({
  declarations: [
    MainLayoutComponent,
    PreAuthLayoutComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    NavigationModule,
    NavigationModule
  ],
  exports: [
    MainLayoutComponent,
    PreAuthLayoutComponent
  ]
})
export class LayoutModule {
}
